const isMapPortal = (): boolean => {
  const url = new URL(window.location.href);
  const params = url.searchParams;

  return (
    params.has('zoom') &&
    params.has('lat') &&
    params.has('lng') &&
    !params.has('redirect')
  );
};

export default isMapPortal;
